import type { ReactNode } from "react";
import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";

export function ShareNotice({
  children,
  title = t("momentum_modal.share_broadcast.title"),
  description = t("momentum_modal.share_broadcast.description"),
}: {
  children: ReactNode;
  title?: string;
  description?: string;
}) {
  return (
    <div className="bg-secondary flex flex-col gap-y-7 rounded-xl p-6 text-center">
      <div className="flex flex-col gap-y-2 text-pretty px-4">
        <Typography.LabelMd weight="semibold">{title}</Typography.LabelMd>
        <Typography.BodySm color="text-default">
          {description}
        </Typography.BodySm>
      </div>
      {children}
    </div>
  );
}
